/**
 * Ryan O'Dowd
 * 2024-11-11
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import Inner from './Inner';
import Text from './Text';
import Wrapper from './Wrapper';

const PopoverBase = {
  Inner,
  Text,
  Wrapper,
};

export default PopoverBase;
